module.exports = require("plugin-superset-integration/shared/SupersetDashboardsManagement");